import {connect} from "react-redux";
import ValetActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";
import {saveActivity, getPendingActivity} from "../../../../service/Valet/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    senior:state.Dealer.senior,
    saveActivityRes:state.Valet.saveActivityRes,
    pendingActivity:state.Valet.pendingActivity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            activityTypes,
            getSenior,
            saveActivity,
            getPendingActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetActivitySave);
